<template>
  <nav class="sidebar-nav">
    <VuePerfectScrollbar dir="ltr" class="scroll-area" :settings="psSettings">
    <ul v-if="!initializing" class="nav" :dir="$dir.ltr ? 'ltr' : 'rtl'">
      <template v-for="(item, index) in navItems">
        <template v-if="allowed(item)">
          <template v-if="item.title">
            <SidebarNavTitle :key="index" :name="item.name" :classes="item.class" :wrapper="item.wrapper"/>
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider :key="index" :classes="item.class"/>
          </template>
          <template v-else-if="item.label">
            <SidebarNavLabel :key="index" :name="item.name" :url="item.url" :icon="item.icon" :label="item.label" :classes="item.class"/>
          </template>
          <template v-else>
            <template v-if="item.children">
              <!-- First level dropdown -->
              <SidebarNavDropdown :key="index" :name="item.name" :url="item.url" :icon="item.icon">
                <template v-for="(childL1, index1) in item.children">
                  <template v-if="allowed(childL1)">
                    <template v-if="childL1.children">
                      <!-- Second level dropdown -->
                      <SidebarNavDropdown :key="index1" :name="childL1.name" :url="childL1.url" :icon="childL1.icon">
                        <template v-for="(childL2, index2) in childL1.children">
                          <li v-if="allowed(childL2)" :key="index2" class="nav-item">
                            <SidebarNavLink :name="childL2.name" :url="childL2.url" :icon="childL2.icon" :badge="childL2.badge" :variant="item.variant"/>
                          </li>
                        </template>
                      </SidebarNavDropdown>
                    </template>
                    <template v-else>
                      <SidebarNavItem :key="index1" :classes="item.class">
                        <SidebarNavLink :name="childL1.name" :url="childL1.url" :icon="childL1.icon" :badge="childL1.badge" :variant="item.variant"/>
                      </SidebarNavItem>
                    </template>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>
            <template v-else>
              <SidebarNavItem :key="index" :classes="item.class">
                <SidebarNavLink :name="item.name" :url="item.url" :icon="item.icon" :badge="item.badge" :variant="item.variant"/>
              </SidebarNavItem>
            </template>
          </template>
        </template>
      </template>
    </ul>
    <slot></slot>
    </VuePerfectScrollbar>
  </nav>
</template>

<script>
import SidebarNavDivider from './SidebarNavDivider'
import SidebarNavDropdown from './SidebarNavDropdown'
import SidebarNavLink from './SidebarNavLink'
import SidebarNavTitle from './SidebarNavTitle'
import SidebarNavItem from './SidebarNavItem'
import SidebarNavLabel from './SidebarNavLabel'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Settings from '@/mixins/settings/index'

export default {
  name: 'SidebarNav',
  mixins: [Settings],
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel,
    VuePerfectScrollbar
  },
  data () {
    return {
      initializing: true,
      psSettings: {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX: true,
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      }
    }
  },
  mounted () {
    this.getSettings('Products')
    .then(() => this.initializing = false)
  },
  methods: {
    allowed (item) {
      const roles = item.roles || []
      const statuses = item.statuses || []
      const settings = item.enabledSettings || []

      const systemSettings = this.$store.state.$settings

      const rolesPassed = !roles.length || this.$api.account.isInAnyOfRoles(roles)

      const statusesPassed = !statuses.length || this.$api.account.hasEveryStatuses(statuses)

      const settingsReducer = (accumulator, setting) => {
        if (!accumulator) return false

        const sArray = setting.split('.')

        return systemSettings[sArray[0]][sArray[1]]

      }

      const enabledSettingsPassed = !settings.length || settings.reduce(settingsReducer, true)

      return rolesPassed && statusesPassed && enabledSettingsPassed
    }
  }
}
</script>

<style scoped lang="css">
  .scroll-area {
    position: absolute;
    height: 100%;
    margin: auto;
  }
</style>
